import { useSelector } from 'react-redux';
import { roundedDurationSelector } from '../../ecg/selectors/ecg.selectors';
import { timestampSelector } from '../../navigation/selectors/navigation.selectors';
import { getMovingWindow } from '../../navigation/utils/timestamp.utils';
import { useStrip } from './useStrip';

export const useMovingWindow = (duration: number) => {
  const ecgDuration = useSelector(roundedDurationSelector);
  const timestamp = useSelector(timestampSelector);
  const { onset, offset } = useStrip();
  return getMovingWindow(timestamp, duration, ecgDuration + onset + offset);
};
